import {useLayoutEffect, useState} from 'react';

import {createDashboardAdaptiveDensityBoard} from '../utils/createDashboardAdaptiveDensityBoard';

/**
 * Owns the board's adaptive density coordinator. The coordinator measures tile DOM outside React,
 * so it learns about a new arrangement in a layout effect: after React commits the moved tiles and
 * before the browser paints them, which keeps tiles from flashing at their old row counts.
 */
export function useDashboardAdaptiveDensityBoard(layoutSignature: string) {
  const [board] = useState(createDashboardAdaptiveDensityBoard);

  useLayoutEffect(
    function updateAdaptiveDensityLayout() {
      board.setLayoutSignature(layoutSignature);
    },
    [board, layoutSignature]
  );

  return board;
}
